import React, {useEffect} from 'react'
import { Link } from 'react-router-dom'
import './ConsultationSuccess.css'
import finalPic from "../../../assets/images/Final pics/Favcon.png";
import success from "../../../assets/images/Final pics/success.png";
import googlePlay from "../../../assets/images/Final pics/googleplay 1.png";

const ConsultationSuccess = () => {
  const handleDownloadApp = () => {
    window.open('https://play.google.com/store/apps/details?id=com.astrocure', '_blank')
  }

    useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="consultation-success-page home-layout-bg">
      {/* Background with grid pattern and glowing effects */}
      <div className="mystical-background">
        <div className="grid-pattern"></div>
      </div>

      {/* Main Content */}
      <main className="main-content hero-section">
        {/* Top Confirmation Section */}
        <div className="confirmation-section">
          {/* Confirmation Icon */}
              <img 
                src={success} 
                alt="AstroCure App Icon" 
                className="app-icon-image"
              />
          
          {/* Main Heading */}
          <h1 className="main-heading">
            Your consultation is successfully scheduled on <span style={{color: "rgba(255, 215, 102, 1)"}}>26 November, 2025 at 10:00 AM.</span>
          </h1>
          
          {/* Sub-message */}
          <p className="sub-message">
          Kindly <span style={{color: "#E5FF00"}}>Download and Sign up on the AstroCure App</span> — the astrologer will connect with you there.
          </p>
        </div>

        {/* App Download Card */}
        <div className="app-download-card">
          {/* App Icon */}
          <div className="app-icon">
            <div className="icon-background">
              <img 
                src={finalPic} 
                alt="AstroCure App Icon" 
                className="app-icon-image"
              />
            </div>
          </div>
          
          {/* Call to Action */}
          <h2 className="download-heading">
            Download the <span className="highlighted-text">AstroCure App</span> now in order to receive your <span className="highlighted-text">15-minute free consultation.</span>
          </h2>
          
          {/* Instructions */}
          <p className="download-instructions">
            Kindly <span className="blink-animate"> Download and Sign up on the AstroCure App </span> — the astrologer will connect with you there.
          </p>
          
          {/* Google Play Button */}
          <div className="google-play-container">
            <img 
              src={googlePlay} 
              alt="Google Play Button" 
              className="google-play-button-image"
              onClick={handleDownloadApp}
            />
          </div>
          
          {/* Side Decorations */}
          <div className="side-decoration left"></div>
          <div className="side-decoration right"></div>
        </div>

        {/* Bottom Download Button */}
        <button className="download-app-btn" onClick={handleDownloadApp}>
          Download AstroCure App
        </button>
            <p className="proceeding-text">
              By proceeding, you accept our 
              <span
                style={{ color: "#7611AE", cursor: "pointer"}}
                onClick={() => {
                  window.open("/terms-and-conditions");
                }}
              >
                {" "} Terms & Conditions
              </span>
            </p>
        <div className="back-link">
          <Link to="/free-campaign" className="back-btn">
            ← Back to Home
          </Link>
        </div>
      </main>
    </div>
  )
}

export default ConsultationSuccess
